import React from "react";
import DebugErrorScreen from "./DebugErrorScreen";

export default class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    // Keep details for debugging; do NOT navigate or change URL
    try {
      // eslint-disable-next-line no-console
      console.error("[GlobalErrorBoundary] Caught error", error, errorInfo);
    } catch (_) {}
    this.setState({ error, errorInfo });
  }

  render() {
    const { error, errorInfo } = this.state;
    if (error) {
      return (
        <div style={{ position: "relative", minHeight: "100vh" }}>
          <DebugErrorScreen
            title="Unhandled UI error"
            error={error}
            details={{
              reactComponentStack: errorInfo?.componentStack || null,
            }}
            allowDismiss={false}
          />
        </div>
      );
    }
    return this.props.children;
  }
}
